<nav
  motif-vertical-navigation
  [show]="!isMenuCollapsed"
  [class.show]="!isMenuCollapsed"
  id="vertical-navigation-menu"
  (document:click)="onDocumentClick($event)"
>
  <ul motif-vertical-navigation-menu>
    <li motif-vertical-navigation-menu-item>
      <a
        motif-vertical-navigation-menu-link
        [routerLink]="pages.LANDING"
        vertical-navigation-menu-item-active
      >
        <motif-icon
          [src]="'/assets/icons/action/ic_home_24px.svg'"
        ></motif-icon>
        <span>Home</span>
      </a>
    </li>
    <li motif-vertical-navigation-menu-item [ngClass]="{'disabled': isDashboardLinkDisabled}">
      <a
        motif-vertical-navigation-menu-link
        [routerLink]="'home/'+clientId"
        vertical-navigation-menu-item-active
      >
        <motif-icon
          [src]="'/assets/icons/action/ic_dashboard_24px.svg'"
        ></motif-icon>
        <span>Dashboard</span>
      </a>
    </li>
    <li motif-vertical-navigation-menu-item [ngClass]="{'disabled': isPowerBILinkDisabled}">
      <a
        motif-vertical-navigation-menu-link
        [routerLink]="['/power-bi-dashboard', clientId, 'COMMAND_CENTER' ]"
      >
        <img src="/assets/images/insert_chart_24dp_FFFF.svg"/>
        <span>Command Center</span>
      </a>
    </li>
    <li motif-vertical-navigation-menu-item [ngClass]="{'disabled': isPowerBILinkDisabled}">
      <a
        motif-vertical-navigation-menu-link
        [routerLink]="['/power-bi-dashboard', clientId, 'DEAL_TRACKING']"
      >
        <img src="/assets/images/auto_graph_24dp_FFFF.svg"/>
        <span>Deal tracking</span>
      </a>
    </li>
    <li motif-vertical-navigation-menu-item [ngClass]="{'disabled': isPowerBILinkDisabled}">
      <a
        motif-vertical-navigation-menu-link
        [routerLink]="['/power-bi-dashboard', clientId, 'RESOURCE_FORECASTING' ]"
      >
      <img src="/assets/images/bar_chart_24dp_FFFF.svg"/>
        <span>Resource utilization & forecast</span>
      </a>
    </li>
    <li motif-vertical-navigation-menu-item [ngClass]="{'disabled': isPowerBILinkDisabled}">
      <a
        motif-vertical-navigation-menu-link
        [routerLink]="['/power-bi-dashboard', clientId, 'TRANSITION' ]"
      >
      <img src="/assets/images/stacked_line_chart_24dp_FFFF.svg"/>
        <span>Transition</span>
      </a>
    </li>
    <li motif-vertical-navigation-menu-item [ngClass]="{'disabled': isPowerBILinkDisabled}">
      <a
        motif-vertical-navigation-menu-link
        [routerLink]="['/power-bi-dashboard', clientId, 'TRANSFORMATION']"
      >
      <img src="/assets/images/show_chart_24dp_FFFF.svg"/>
        <span>Transformation</span>
      </a>
    </li>
    <!-- <li motif-vertical-navigation-menu-item [ngClass]="{'disabled': isPowerBILinkDisabled}">
      <a
        motif-vertical-navigation-menu-link
        [routerLink]="'/home/'+clientId"
      >
      <img src="/assets/images/insert_chart_24dp_FFFF.svg"/>
        <span>Delivery</span>
      </a>
    </li> -->
    <!-- <li motif-vertical-navigation-menu-item>
      <a
        motif-vertical-navigation-menu-link
        [routerLink]="pages.VIEW_REGULATION"
        vertical-navigation-menu-item-active>
        <motif-icon [src]="'/assets/images/view-regulation-icon.svg'"></motif-icon>
        <span>View Regulation</span>
      </a>
    </li>
    <li motif-vertical-navigation-menu-item *ngIf="userServiceRef?.userDetails?.isAdmin===true">
      <a
        motif-vertical-navigation-menu-link
        [routerLink]="pages.HISTORY"
        vertical-navigation-menu-item-active>
        <motif-icon [src]="'/assets/icons/action/ic_history_24px.svg'"></motif-icon>
        <span>History</span>
      </a>
    </li> -->
  </ul>
</nav>
